<template>
  <div class="d-flex flex-column flex-md-row">
    <div
      class="text-center"
    >
      <polygonal-chart
        class="duval-card__chart"
        no-subtitle
        size="small"
        :value="coordinates"
        :type="type"
      />
    </div>
    <diagnostic-text-panel
      class="ml-md-3"
      :empty-diagnosis-is-normal="false"
      :data="data"
      :alarmed="alarmed"
    />
  </div>
</template>
<style lang="sass" scoped>
.duval-card
  &__chart
    width: 100%
</style>
<script>
import PolygonalChart from '@/domain/components/installation/engineering/chromatography/polygonalChart';
import DiagnosticTextPanel from '../common/DiagnosticTextPanel';

export default {
  props: {
    /*
     * Tipo do triângulo para ser plotado no gráfco
     * @/domain/enums/polygonalCharts/polygonalChart
    */
    type: String,
    /*
     * Coordenada do ponto a ser inserido no triângulo
     * { x: number, y: number }
     *
    */
    coordinates: Object,
    /*
     * Objeto data com informações sobre a porcentagem dos elementos,
     * diagnóstico e recomendações
     *
     * {
     *   percentageCH4: number
     *   percentageC2H4: number
     *   percentageC2H2: number
     *   percentageC2H6: number
     *   percentageH2: number
     *   recommendations: string[]
     *   diagnostics: string[]
     * }
     *
    */
    data: Object,
    /**
     * Define estado de alarmado.
     */
    alarmed: Boolean,
  },
  components: {
    PolygonalChart,
    DiagnosticTextPanel,
  },
};
</script>
